import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function bulkAssignmentToastsReducer(state = initialState.bulkAssignmentToasts, action) {
	switch (action.type) {
		case types.ADD_BULK_ASSIGNMENTS_TOAST: {
			let newState = [{...action.payload, closed: false}];
			// newState.push({...action.payload, closed: false});
			return newState;
		}
		case types.REMOVE_BULK_ASSIGNMENTS_TOAST: {
			let newState = _.cloneDeep(state);
			newState[action.payload.index].closed = true;
			return newState;
		}
		default:
			return state;
	}
}
